import { createSlice } from "@reduxjs/toolkit";
import { getTopupPacks } from "./_topupPacksAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

export const topupPacksList = createSlice({
  name: "topupPacks",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getTopupPacks.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getTopupPacks.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getTopupPacks.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
  },
});
